import React, { useMemo } from 'react';

const Overview = ({ timeSeriesData, dateRange, recentOrders: recentOrdersProp }) => {
  const recentOrders = Array.isArray(recentOrdersProp) ? recentOrdersProp : [];

  const RevenueChart = () => {
    if (!timeSeriesData || timeSeriesData.length === 0) return null;
    const maxRevenue = Math.max(1, ...(timeSeriesData.map(d => Number(d.revenue) || 0)));
    return (
      <div className="space-y-2">
        <div className="flex items-end justify-between h-32 gap-1">
          {timeSeriesData.slice(-7).map((data, idx) => {
            const rev = Number(data.revenue) || 0;
            const pct = maxRevenue > 0 ? (rev / maxRevenue) * 100 : 0;
            return (
              <div key={idx} className="flex-1 flex flex-col items-center">
                <div
                  className="w-full bg-gradient-to-t from-blue-500 to-blue-300 rounded-t transition-all hover:opacity-80"
                  style={{ height: `${pct}%`, minHeight: '2px' }}
                  title={`₹${rev.toLocaleString()}`}
                />
                <span className="text-xs text-gray-500 mt-1">
                  {new Date(data.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-6">
      
      {/* Orders Summary */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-lg p-4 border border-gray-200">
          <p className="text-sm text-gray-600 mb-1">Pending</p>
          <p className="text-2xl font-bold text-orange-600">
            {recentOrders.filter(o => o.status === 'Pending Payment' || o.status === 'Pending' || o.status === 'Confirmed').length}
          </p>
        </div>
        <div className="bg-white rounded-lg p-4 border border-gray-200">
          <p className="text-sm text-gray-600 mb-1">Processing</p>
          <p className="text-2xl font-bold text-yellow-600">
            {recentOrders.filter(o => o.status === 'In-Progress' || o.status === 'Processing').length}
          </p>
        </div>
        <div className="bg-white rounded-lg p-4 border border-gray-200">
          <p className="text-sm text-gray-600 mb-1">Shipped</p>
          <p className="text-2xl font-bold text-blue-600">
            {recentOrders.filter(o => o.status === 'Shipped').length}
          </p>
        </div>
        <div className="bg-white rounded-lg p-4 border border-gray-200">
          <p className="text-sm text-gray-600 mb-1">Delivered</p>
          <p className="text-2xl font-bold text-green-600">
            {recentOrders.filter(o => o.status === 'Delivered').length}
          </p>
        </div>
      </div>

      {/* Recent Orders */}
      <div>
        <h4 className="font-semibold text-gray-900 mb-4">Recent Orders</h4>
        <div className="space-y-3">
          {recentOrders.slice(0, 5).map((order, idx) => {
            const orderDate = order.date ? (typeof order.date === 'string' ? order.date : new Date(order.date).toLocaleDateString()) : 'N/A';
            return (
              <div key={order.id || order.orderId || `order-${idx}`} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-md transition">
                <div>
                  <h5 className="font-semibold text-gray-900">{order.orderId || '—'}</h5>
                  <p className="text-sm text-gray-600">{order.customer || 'Unknown'} • {order.items ?? 0} items</p>
                  <p className="text-xs text-gray-500 mt-1">{orderDate}</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-gray-900">₹{(Number(order.amount) || 0).toLocaleString()}</p>
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    order.status === 'Delivered' ? 'bg-green-100 text-green-800' :
                    order.status === 'Shipped' ? 'bg-blue-100 text-blue-800' :
                    order.status === 'In-Progress' || order.status === 'Processing' ? 'bg-yellow-100 text-yellow-800' :
                    order.status === 'Pending Payment' || order.status === 'Pending' || order.status === 'Confirmed' ? 'bg-orange-100 text-orange-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {order.status}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Overview;

